import { useEffect } from 'react';

import { useSingleRoot } from './SingleRootContext';
import { markUnsavedChanges } from './unsavedChanges';

/**
 * Tells the shell a page has unsaved changes without asking before leave, for a page that asks
 * in its own way (`useUnsavedChangesGuard` asks for it). The shell then shows this tab as editing
 * and holds refreshes that would reset the page. Records nothing outside the shell.
 */
export const useReportUnsavedChanges = (isDirty: boolean): void => {
  const inShell = useSingleRoot() !== null;
  useEffect(() => (inShell && isDirty ? markUnsavedChanges() : undefined), [inShell, isDirty]);
};
